import * as React from 'react';
import { SVGProps } from 'react';

const IconEraseSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.394 14.01a1 1 0 0 1-.682-.268l-2.42-2.257a1 1 0 0 1 0-1.414l7.78-7.778a1 1 0 0 1 1.413 0l4.243 4.243a1 1 0 0 1 0 1.414l-4.06 4.06H15v2H4.394Zm.252-2-1.232-1.232L5.78 8.412l2.829 2.829-.77.77H4.646Z"
    />
  </svg>
);
export default IconEraseSizeS;
